var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_3704)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_197_3704)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_197_3704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2102 76.0001L92.6702 69.4901L78.2102 63.0001L87.4802 50.1401L71.7302 51.8201L73.3302 36.0001L60.5202 45.3501L54.0002 30.8901L47.5802 45.3601L34.7102 36.0901L36.3702 51.8301L20.6002 50.2401L29.9102 63.0501L15.4502 69.5501L29.9102 76.0001L20.6402 88.8501L36.3902 87.1901L34.7902 103L47.6002 93.6601L54.1102 108.12L60.5402 93.6501L73.4102 102.92L71.7502 87.1801L87.5202 88.7701L78.2102 76.0001Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2102 76.0001L92.6702 69.4901L78.2102 63.0001L87.4802 50.1401L71.7302 51.8201L73.3302 36.0001L60.5202 45.3501L54.0002 30.8901L47.5802 45.3601L34.7102 36.0901L36.3702 51.8301L20.6002 50.2401L29.9102 63.0501L15.4502 69.5501L29.9102 76.0001L20.6402 88.8501L36.3902 87.1901L34.7902 103L47.6002 93.6601L54.1102 108.12L60.5402 93.6501L73.4102 102.92L71.7502 87.1801L87.5202 88.7701L78.2102 76.0001Z",
    fill: "#E6E6E6"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M79.85 76.4601L95.21 69.5501L79.85 62.7201L89.69 49.0601L73 50.8201L74.7 34.0701L61.07 44.0001L54.16 28.6001L47.33 44.0001L33.67 34.1201L35.43 50.8401L18.68 49.1401L28.56 62.7401L13.21 69.6501L28.57 76.4801L18.73 90.1401L35.45 88.3801L33.75 105.13L47.35 95.2401L54.26 110.6L61.09 95.2401L74.75 105.08L73 88.3601L89.75 90.0601L79.85 76.4601Z",
    fill: "url(#paint0_radial_197_3704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4903 82.1001C34.9637 86.3809 38.6509 89.8322 43.0857 92.0176C47.5204 94.2031 52.5036 95.0246 57.4051 94.3782C62.3067 93.7319 66.9065 91.6467 70.6232 88.3863C74.3398 85.126 77.0062 80.8368 78.2854 76.0612C79.5646 71.2855 79.3991 66.2378 77.8098 61.5563C76.2205 56.8747 73.2788 52.7694 69.3565 49.7596C65.4343 46.7497 60.7077 44.9703 55.7744 44.6465C50.841 44.3226 45.9223 45.4688 41.6403 47.9401C38.7959 49.5817 36.3028 51.7676 34.3035 54.373C32.3042 56.9783 30.8377 59.9521 29.988 63.1244C29.1383 66.2967 28.9219 69.6053 29.3513 72.8612C29.7806 76.1171 30.8473 79.2565 32.4903 82.1001Z",
    fill: "#FFD348"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9996 80.1002C38.0764 83.6968 41.1731 86.5969 44.8979 88.4337C48.6228 90.2705 52.8087 90.9616 56.9264 90.4195C61.044 89.8775 64.9084 88.1266 68.0311 85.3884C71.1537 82.6502 73.3943 79.0476 74.4695 75.036C75.5448 71.0245 75.4064 66.7842 74.0719 62.8513C72.7374 58.9184 70.2666 55.4695 66.9721 52.9407C63.6776 50.4119 59.7072 48.9168 55.563 48.6444C51.4188 48.3719 47.2868 49.3345 43.6896 51.4102C41.3006 52.7888 39.2066 54.6246 37.5271 56.8126C35.8476 59.0006 34.6157 61.498 33.9016 64.1623C33.1874 66.8265 33.0052 69.6053 33.3652 72.34C33.7252 75.0746 34.6204 77.7116 35.9996 80.1002Z",
    fill: "url(#paint1_linear_197_3704)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.85 76.4601L95.21 69.5501L79.85 62.7201L89.69 49.0601L73 50.8201L74.7 34.0701L61.07 44.0001L54.16 28.6001L47.33 44.0001L33.67 34.1201L35.43 50.8401L18.68 49.1401L28.56 62.7401L13.21 69.6501L28.57 76.4801L18.73 90.1401L35.45 88.3801L33.75 105.13L47.35 95.2401L54.26 110.6L61.09 95.2401L74.75 105.08L73 88.3601L89.75 90.0601L79.85 76.4601Z",
    stroke: "#F29B1C",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_197_3704",
    x: -4.5498,
    y: 10.8901,
    width: 117.22,
    height: 117.23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "effect1_foregroundBlur_197_3704"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_197_3704",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.21 69.6001) scale(41)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#D6B849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#FFCE47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_3704",
    x1: 40.6396,
    y1: 53.5102,
    x2: 67.6496,
    y2: 85.6902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAF22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#F09900"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_3704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.56,
    height: 154.56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_197_3704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.56,
    height: 154.56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.76a916cc0cdb5d7a12219bf32199e428.svg";
export { ForwardRef as ReactComponent };